import React from "react";

const SearchIconV2 = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_2548_335"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="30"
        height="30"
      >
        <rect width="30" height="30" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_2548_335)">
        <path
          d="M13.75 12.5C14.4375 12.5 15.026 12.2552 15.5156 11.7656C16.0052 11.276 16.25 10.6875 16.25 10C16.25 9.3125 16.0052 8.72396 15.5156 8.23438C15.026 7.74479 14.4375 7.5 13.75 7.5C13.0625 7.5 12.474 7.74479 11.9844 8.23438C11.4948 8.72396 11.25 9.3125 11.25 10C11.25 10.6875 11.4948 11.276 11.9844 11.7656C12.474 12.2552 13.0625 12.5 13.75 12.5ZM13.75 17.5C14.6875 17.5 15.5677 17.3021 16.3906 16.9063C17.2135 16.5104 17.9271 15.9479 18.5312 15.2188C17.8021 14.7396 17.0365 14.375 16.2344 14.125C15.4323 13.875 14.6042 13.75 13.75 13.75C12.8958 13.75 12.0677 13.875 11.2656 14.125C10.4635 14.375 9.69792 14.7396 8.96875 15.2188C9.57292 15.9479 10.2865 16.5104 11.1094 16.9063C11.9323 17.3021 12.8125 17.5 13.75 17.5ZM25.75 26.25L19.875 20.375C19.0208 21.0417 18.0781 21.5625 17.0469 21.9375C16.0156 22.3125 14.9167 22.5 13.75 22.5C10.9583 22.5 8.59375 21.5312 6.65625 19.5938C4.71875 17.6562 3.75 15.2917 3.75 12.5C3.75 9.70833 4.71875 7.34375 6.65625 5.40625C8.59375 3.46875 10.9583 2.5 13.75 2.5C16.5417 2.5 18.9062 3.46875 20.8438 5.40625C22.7812 7.34375 23.75 9.70833 23.75 12.5C23.75 13.6667 23.5625 14.7656 23.1875 15.7969C22.8125 16.8281 22.2917 17.7708 21.625 18.625L27.5 24.5L25.75 26.25ZM13.75 20C15.8333 20 17.6042 19.2708 19.0625 17.8125C20.5208 16.3542 21.25 14.5833 21.25 12.5C21.25 10.4167 20.5208 8.64583 19.0625 7.1875C17.6042 5.72917 15.8333 5 13.75 5C11.6667 5 9.89583 5.72917 8.4375 7.1875C6.97917 8.64583 6.25 10.4167 6.25 12.5C6.25 14.5833 6.97917 16.3542 8.4375 17.8125C9.89583 19.2708 11.6667 20 13.75 20Z"
          fill="#03579E"
        />
      </g>
    </svg>
  );
};

export default SearchIconV2;
